import { render, staticRenderFns } from "./OssReactionsButton.vue?vue&type=template&id=7fcd637b&scoped=true"
import script from "./OssReactionsButton.vue?vue&type=script&lang=js"
export * from "./OssReactionsButton.vue?vue&type=script&lang=js"
import style0 from "./OssReactionsButton.vue?vue&type=style&index=0&id=7fcd637b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd637b",
  null
  
)

export default component.exports